import { useCallback, useEffect, useState } from 'react';
import { Container, Stack, Paper, Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import Back from '../../../components/common/Back.component';
import EditView from '../../../views/Edit.view';
import Loading from '../../../components/common/Loading.component';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Alert from '../../../components/common/Alert.component';
import { fetchAPI } from '../../../api/request';

const DeliveryNoteEditPage = ({ module: { edit, query } }) => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { id, id_operation } = useParams();
  const { jwt } = useSelector((state) => state.login);
  const {
    loading: loadingGet,
    data,
    error: errorGET,
  } = useSelector(edit.selector.data);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);

  const onError = useCallback(() => {
    setSuccess(false);
    setLoading(false);
    setError(true);
    // eslint-disable-next-line
  }, []);

  const onSuccess = useCallback(() => {
    setSuccess(true);
    setError(false);
    setLoading(false);
    // eslint-disable-next-line
  }, []);

  const onSubmit = useCallback(
    (values) => {
      const obj = {
        ...values,
        id_operation_list: state?.id,
        id_logbook: data?.id_logbook?.id,
      };

      setError(false);
      setSuccess(false);
      setLoading(true);
      fetchAPI(query?.edit?.settings, { id }, '', { data: obj }, jwt)
        .then((resp) => onSuccess(resp))
        .catch(onError);
    },
    [
      state,
      data,
      jwt,
      setError,
      setSuccess,
      setLoading,
      id,
      onError,
      onSuccess,
      query,
    ]
  );
  useEffect(() => {
    dispatch(
      query.detail.action({
        settings: query.detail.settings,
        token: jwt,
        params: { id },
        query: { populate: query.detail.populate },
      })
    );

    return () => {
      dispatch(
        query.detail.action({
          settings: null,
          token: null,
          params: null,
          query: null,
        })
      );
    };
  }, [dispatch, jwt, id, query]);

  useEffect(() => {
    if (
      (errorGET &&
        (errorGET?.response?.status === 404 ||
          errorGET?.response?.status === 500)) ||
      state?.id !== id_operation
    )
      navigate('/404');
  }, [errorGET, navigate, state, id_operation]);

  return (
    <Container disableGutters={true} maxWidth={false} sx={{ height: '100%' }}>
      <Stack
        spacing={2}
        sx={{ padding: 2 }}
        justifyContent='center'
        alignItems='center'
      >
        <Back />
        <Container>
          {loading && <Loading />}
          {success && <Alert severity='success'>{'Success: Updated!'}</Alert>}
          {error && <Alert severity='error'>{'An error has occurred'}</Alert>}

          <Paper variant='outlined'>
            <Box sx={{ padding: 2 }}>
              <EditView
                data={data}
                conf={edit.conf}
                onEditSubmit={onSubmit}
                disabled={loading || loadingGet || success}
              />
            </Box>
          </Paper>
        </Container>
      </Stack>
    </Container>
  );
};

export default DeliveryNoteEditPage;
